import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PopoverController } from '@ionic/angular';

import { ChatEmojiPickerComponent } from '../chat-emoji-picker/chat-emoji-picker.component';


@Component({
  selector: 'itl-chat-message-input',
  templateUrl: './chat-message-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChatMessageInputComponent),
      multi: true,
    },
  ],
})
export class ChatMessageInputComponent implements ControlValueAccessor {
  @Output() submit: EventEmitter<void> = new EventEmitter();
  @Input() showSendButton: boolean;
  @Input() placeholder = '';
  @Input() showEmojiPicker = true;
  @Input() sendOnEnter = true;
  @Input() isActive = true;
  @Input() formControl: UntypedFormControl;
  value = '';
  private onChange = (_text: string) => { };
  private onTouched = () => { };

  public message = '';

  constructor(private popoverController: PopoverController, private changeDetectorRef: ChangeDetectorRef) { }

  public async presentPopover(ev: Event) {
    if (!this.isActive) {
      return;
    }
    const popover = await this.popoverController.create({
      component: ChatEmojiPickerComponent,
      event: ev,
      translucent: false,
    });
    await popover.present();
    const result = await popover.onDidDismiss();
    if (result.data) {
      this.addEmoji(result.data);
    }
  }

  public handleSubmit() {
    this.submit.emit();
  }

  public addEmoji(emoji: string) {
    this.formControl.setValue(this.formControl.value + emoji);
    this.changeDetectorRef.markForCheck();
  }

  public markAsTouched(): void {
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
